import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlertOPEEnum} from "./AlertOPEEnum";
import {UserMetricInstance} from "../../models/user/Metric/UserMetricInstance";
import {Alarm, AlarmTypeEnum, MetricInstanceAlertEntityAdditionalInfo} from "../../models/diagnostic/PartitionAlarm";

/**
 * O Inner Class
 */
class O {
  id!: number;
  name!: string;
  enabled!: boolean;
  beginAlarmNotificationOn!: boolean;
  endAlarmNotificationOn!: boolean;
  alarmType!: AlarmTypeEnum;
  additionalInfo?: MetricInstanceAlertEntityAdditionalInfo;
  metricInstance!: UserMetricInstance;
  alarm!: Alarm;

}

class I {

  partitionId!: number;
  id!: number;

}

export class GetMetricInstanceAlertStatusDetailCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AlertOPEEnum.GetMetricInstanceAlertStatusDetail);
    this.i = new I();
    this.o = new O();
  }
}
